import { Icon, IconStatus, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { ManagementFeeStatus } from '../../../../../store/rateManagement/constants';

import { MasterAccountField } from './MasterAccountField';

import { CardTypes } from '.';

export const CardMobile: React.FC<CardTypes.Props> = ({ loading, sentOrderDetail }) => {
  const getStatusIcon = () => {
    if (
      sentOrderDetail?.managementFeeStatusIconNormalized &&
      sentOrderDetail?.managementFeeStatusIconColorNormalized &&
      sentOrderDetail?.managementFeeStatusIconSizeNormalized &&
      sentOrderDetail?.managementFeeStatusIconBackgroundNormalized
    ) {
      return (
        <IconStatus
          icon={sentOrderDetail?.managementFeeStatusIconNormalized}
          color={sentOrderDetail?.managementFeeStatusIconColorNormalized}
          testId="header-section-status-icon"
          size={sentOrderDetail?.managementFeeStatusIconSizeNormalized}
          bgColor={sentOrderDetail?.managementFeeStatusIconBackgroundNormalized}
        />
      );
    }
  };

  const currentStatus = getStatusIcon();

  return (
    <VStack mb={Spacing['stack.xxxs']}>
      <VStack
        borderRadius="lg"
        shadow={1}
        backgroundColor={Color['neutral.white']}
        p={Spacing['stack.xxxs']}
        space={Spacing['stack.xxxs']}>
        <HStack
          justifyContent="space-between"
          width="full"
          space={Spacing['stack.quarck']}
          alignItems="center">
          <Text fontWeight={Typography['fontweight.semibold']} fontSize={Typography['fontsize.lg']}>
            Detalhes da solicitação
          </Text>
          <Icon name="Pdf" color={Color['brand.tertiary.principal']} size="sm" testId="pdf-icon" />
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>Status</Text>
          <HStack
            justifyContent="flex-end"
            flex={1}
            space={Spacing['stack.quarck']}
            alignItems="center">
            {loading ? (
              <Skeleton testID="test-skeleton" borderRadius={'sm'} height={'14px'} />
            ) : (
              <>
                {currentStatus}
                <Text pl={Spacing['inset.quarck']}>
                  {sentOrderDetail?.managementFeeStatusTextNormalized}
                </Text>
              </>
            )}
          </HStack>
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>ID solicitação</Text>
          <Text flex={1} textAlign="right" isLoading={loading}>
            {sentOrderDetail?.managementFeeHashNormalized}
          </Text>
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>Mês de referência </Text>
          <Text flex={1} textAlign="right" isLoading={loading}>
            {sentOrderDetail?.managementFeeMonthNormalized}
          </Text>
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>Tipo</Text>
          <Text flex={1} textAlign="right" isLoading={loading}>
            {sentOrderDetail?.managementFeeTypeNormalized}
          </Text>
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>Total de clientes</Text>

          <HStack
            justifyContent="flex-end"
            flex={1}
            space={Spacing['stack.quarck']}
            alignItems="center">
            {loading ? (
              <Skeleton testID="test-skeleton" borderRadius={'sm'} height={'14px'} />
            ) : (
              <>
                <Icon
                  name="People"
                  size="xxs"
                  testId="people-icon"
                  color={Color['neutral.medium']}
                />
                <Text textAlign="right" pl={Spacing['inset.quarck']}>
                  {sentOrderDetail?.customerTotal}
                </Text>
              </>
            )}
          </HStack>
        </HStack>
        <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
          <Text>Clientes adicionados</Text>

          <HStack
            justifyContent="flex-end"
            flex={1}
            space={Spacing['stack.quarck']}
            alignItems="center">
            {loading ? (
              <Skeleton testID="test-skeleton" borderRadius={'sm'} height={'14px'} />
            ) : (
              <>
                <Icon
                  name="Check"
                  color={Color['feedback.success.default']}
                  size="xxs"
                  testId="status-icon"
                  variant="rounded"
                  padding={2}
                  backgroundColor={Color['feedback.success.lightest']}
                />
                <Text textAlign="right" pl={Spacing['inset.quarck']}>
                  {sentOrderDetail?.validCustomerTotal}
                </Text>
              </>
            )}
          </HStack>
        </HStack>
        {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Processed ||
          sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Cancelled) && (
          <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
            <Text>Clientes inválidos</Text>

            <HStack
              justifyContent="flex-end"
              flex={1}
              space={Spacing['stack.quarck']}
              alignItems="center">
              {loading ? (
                <Skeleton testID="test-skeleton" borderRadius={'sm'} height={'14px'} />
              ) : (
                <>
                  <Icon
                    name="Close"
                    color={Color['feedback.error.default']}
                    size="xxs"
                    testId="close-icon"
                    variant="rounded"
                    backgroundColor={Color['feedback.error.lightest']}
                  />
                  <Text textAlign="right" pl={Spacing['inset.quarck']}>
                    {sentOrderDetail?.invalidCustomerTotal}
                  </Text>
                </>
              )}
            </HStack>
          </HStack>
        )}

        <HStack width="full" space={Spacing['stack.quarck']} alignItems={'center'}>
          <Text>Total a receber</Text>
          <Text flex={1} textAlign="right" isLoading={loading}>
            {sentOrderDetail?.totalAmountToReceiveNormalized}
          </Text>
        </HStack>

        {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Sent ||
          sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Scheduled) && (
          <HStack width="full" space={Spacing['stack.quarck']} alignItems="center">
            <Text>Data de envio</Text>
            <Text flex={1} textAlign="right" isLoading={loading}>
              {sentOrderDetail?.managementFeeSentAtNormalized}
            </Text>
          </HStack>
        )}
        {sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Scheduled && (
          <HStack width="full" space={Spacing['stack.quarck']} alignItems={'center'}>
            <HStack flex={1} space={Spacing['stack.quarck']} alignItems={'center'}>
              <Text color={'neutral.black'} fontSize={Typography['fontsize.xs']} variant="regular">
                <Text fontWeight={Typography['fontweight.semibold']}>Atenção:</Text> Antes do envio,
                faremos outro processamento. É possível que ocorram divergências na solicitação
              </Text>
            </HStack>
          </HStack>
        )}
        {sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Processed &&
          !sentOrderDetail.managerInfo.isManager && (
            <Box>
              <Text fontSize={Typography['fontsize.xs']}>
                **A conta informada será nomeada como a padrão para o recebimento de taxas.
              </Text>
            </Box>
          )}

        <MasterAccountField loading={loading} sentOrderDetail={sentOrderDetail} />
      </VStack>
    </VStack>
  );
};
